// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file case/v1/case_init.proto (package case.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../mobility/v1/common_pb";
import { file_mobility_v1_common } from "../../mobility/v1/common_pb";
import type { VehicleCategory } from "../../mobility/v1/vehicle_pb";
import { file_mobility_v1_vehicle } from "../../mobility/v1/vehicle_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file case/v1/case_init.proto.
 */
export const file_case_v1_case_init: GenFile = /*@__PURE__*/
  fileDesc("ChdjYXNlL3YxL2Nhc2VfaW5pdC5wcm90bxIHY2FzZS52MSKZAwoRQ3JlYXRlQ2FzZVJlcXVlc3QSHgoWYmVuZWZpY2lhcnlfZmlyc3RfbmFtZRgBIAEoCRIdChViZW5lZmljaWFyeV9sYXN0X25hbWUYAiABKAkSMAoVYmVuZWZpY2lhcnlfYmlydGhkYXRlGAMgASgLMhEubW9iaWxpdHkudjEuRGF0ZRIZChFiZW5lZmljaWFyeV9waG9uZRgEIAEoCRITCgtjYXNlX251bWJlchgFIAEoCRITCgtjb250cmFjdF9pZBgGIAEoCRIYChBwYXNzZW5nZXJzX2NvdW50GAcgASgFEiwKDWluY2lkZW50X3R5cGUYCCABKA4yFS5jYXNlLnYxLkluY2lkZW50VHlwZRIVCg12ZWhpY2xlX21vZGVsGAkgASgJEhwKFHZlaGljbGVfcGxhdGVfbnVtYmVyGAogASgJEjYKEHZlaGljbGVfY2F0ZWdvcnkYCyABKA4yHC5tb2JpbGl0eS52MS5WZWhpY2xlQ2F0ZWdvcnkSGQoRYmVuZWZpY2lhcnlfZW1haWwYDCABKAkqkAQKDEluY2lkZW50VHlwZRIdChlJTkNJREVOVF9UWVBFX1VOU1BFQ0lGSUVEEAASJQohSU5DSURFTlRfVFlQRV9URUNITklDQUxfQlJFQUtET1dOEAESHgoaSU5DSURFTlRfVFlQRV9GTEFUX0JBVFRFUlkQAhIaChZJTkNJREVOVF9UWVBFX0FDQ0lERU5UEAMSFgoSSU5DSURFTlRfVFlQRV9GSVJFEAQSGwoXSU5DSURFTlRfVFlQRV9WQU5EQUxJU00QBRIgChxJTkNJREVOVF9UWVBFX0NMSU1BVEVfRVZFTlRTEAYSGwoXSU5DSURFTlRfVFlQRV9GTEFUX1RZUkUQBxIeChpJTkNJREVOVF9UWVBFX0xBQ0tfT0ZfRlVFTBAIEhwKGElOQ0lERU5UX1RZUEVfT1RIRVJfRlVFTBAJEicKI0lOQ0lERU5UX1RZUEVfVkVISUNMRV9PVVRfT0ZfQ0hBUkdFEAoSHAoYSU5DSURFTlRfVFlQRV9LRVlfSVNTVUVTEAsSJQohSU5DSURFTlRfVFlQRV9WRUhJQ0xFX0JPR0dFRF9ET1dOEAwSIAocSU5DSURFTlRfVFlQRV9TVE9MRU5fVkVISUNMRRANEhcKE0lOQ0lERU5UX1RZUEVfVEhFRlQQDhIjCh9JTkNJREVOVF9UWVBFX0JST0tFTl9XSU5EU0hJRUxEEA9COFo2Z2l0aHViLmNvbS90aGV0cmVlcC9hNnRyL2JhY2tlbmQvZ2VuL2dvL2Nhc2UvdjE7Y2FzZXYxYgZwcm90bzM", [file_mobility_v1_common, file_mobility_v1_vehicle]);

/**
 * CreateCaseRequest - creates a Case and activates an initial Mission for the chosen GUARANTEE.
 *
 * @generated from message case.v1.CreateCaseRequest
 */
export type CreateCaseRequest = Message<"case.v1.CreateCaseRequest"> & {
  /**
   * @generated from field: string beneficiary_first_name = 1;
   */
  beneficiaryFirstName: string;

  /**
   * @generated from field: string beneficiary_last_name = 2;
   */
  beneficiaryLastName: string;

  /**
   * @generated from field: mobility.v1.Date beneficiary_birthdate = 3;
   */
  beneficiaryBirthdate?: Date;

  /**
   * @generated from field: string beneficiary_phone = 4;
   */
  beneficiaryPhone: string;

  /**
   * @generated from field: string case_number = 5;
   */
  caseNumber: string;

  /**
   * @generated from field: string contract_id = 6;
   */
  contractId: string;

  /**
   * @generated from field: int32 passengers_count = 7;
   */
  passengersCount: number;

  /**
   * @generated from field: case.v1.IncidentType incident_type = 8;
   */
  incidentType: IncidentType;

  /**
   * @generated from field: string vehicle_model = 9;
   */
  vehicleModel: string;

  /**
   * @generated from field: string vehicle_plate_number = 10;
   */
  vehiclePlateNumber: string;

  /**
   * @generated from field: mobility.v1.VehicleCategory vehicle_category = 11;
   */
  vehicleCategory: VehicleCategory;

  /**
   * @generated from field: string beneficiary_email = 12;
   */
  beneficiaryEmail: string;
};

/**
 * Describes the message case.v1.CreateCaseRequest.
 * Use `create(CreateCaseRequestSchema)` to create a new message.
 */
export const CreateCaseRequestSchema: GenMessage<CreateCaseRequest> = /*@__PURE__*/
  messageDesc(file_case_v1_case_init, 0);

/**
 * IncidentType - nature of the incident that opened the assistance Case (cause du sinistre).
 *
 * @generated from enum case.v1.IncidentType
 */
export enum IncidentType {
  /**
   * @generated from enum value: INCIDENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INCIDENT_TYPE_TECHNICAL_BREAKDOWN = 1;
   */
  TECHNICAL_BREAKDOWN = 1,

  /**
   * @generated from enum value: INCIDENT_TYPE_FLAT_BATTERY = 2;
   */
  FLAT_BATTERY = 2,

  /**
   * @generated from enum value: INCIDENT_TYPE_ACCIDENT = 3;
   */
  ACCIDENT = 3,

  /**
   * @generated from enum value: INCIDENT_TYPE_FIRE = 4;
   */
  FIRE = 4,

  /**
   * @generated from enum value: INCIDENT_TYPE_VANDALISM = 5;
   */
  VANDALISM = 5,

  /**
   * @generated from enum value: INCIDENT_TYPE_CLIMATE_EVENTS = 6;
   */
  CLIMATE_EVENTS = 6,

  /**
   * @generated from enum value: INCIDENT_TYPE_FLAT_TYRE = 7;
   */
  FLAT_TYRE = 7,

  /**
   * @generated from enum value: INCIDENT_TYPE_LACK_OF_FUEL = 8;
   */
  LACK_OF_FUEL = 8,

  /**
   * @generated from enum value: INCIDENT_TYPE_OTHER_FUEL = 9;
   */
  OTHER_FUEL = 9,

  /**
   * @generated from enum value: INCIDENT_TYPE_VEHICLE_OUT_OF_CHARGE = 10;
   */
  VEHICLE_OUT_OF_CHARGE = 10,

  /**
   * @generated from enum value: INCIDENT_TYPE_KEY_ISSUES = 11;
   */
  KEY_ISSUES = 11,

  /**
   * @generated from enum value: INCIDENT_TYPE_VEHICLE_BOGGED_DOWN = 12;
   */
  VEHICLE_BOGGED_DOWN = 12,

  /**
   * @generated from enum value: INCIDENT_TYPE_STOLEN_VEHICLE = 13;
   */
  STOLEN_VEHICLE = 13,

  /**
   * @generated from enum value: INCIDENT_TYPE_THEFT = 14;
   */
  THEFT = 14,

  /**
   * @generated from enum value: INCIDENT_TYPE_BROKEN_WINDSHIELD = 15;
   */
  BROKEN_WINDSHIELD = 15,
}

/**
 * Describes the enum case.v1.IncidentType.
 */
export const IncidentTypeSchema: GenEnum<IncidentType> = /*@__PURE__*/
  enumDesc(file_case_v1_case_init, 0);

